module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-fluted-hamilton-0.c7214f9a.jpg";